<script>

    import { ShipmentStore } from '../stores'

    import MenuMain from '../$layouts/menu.main.svelte'
    import Tabs from '../$components/tabs.svelte'

    import Modal from '../$components/modal.svelte'
    import Shipments from '../shipments/shipments.svelte'
    import ShipmentRead from '../shipments/shipment.svelte'
    import TicketCreate from '../tickets/ticket.create.svelte'
    import PickupCreate from '../pickups/pickup.create.svelte'
    import Trackings from '../trackings/trackings.svelte'

    let selected = 'information'

</script>

<MenuMain />

<div class="container">
    <div class="title is-3">Envíos</div>
    <hr>
    <Shipments />
</div>

<Modal id="ShipmentRead" title="Información">
    <Tabs bind:selected={selected} options={[
            {value: 'information', text: 'Informacion', icon: 'info-circle'},
            {value: 'tracking', text: 'Tracking', icon: 'map-marker-alt'}
        ]} 
    />
    {#if selected === 'information'}
        <ShipmentRead />
    {/if}
    {#if selected === 'tracking'}
        <Trackings />
    {/if}
</Modal>

<Modal id="TicketCreate" title="Agregar ticket" on:close={() => ShipmentStore.modalRead()} >
    <TicketCreate on:created={() => ShipmentStore.modalRead()} on:canceled={() => ShipmentStore.modalRead()} />
</Modal>

<Modal id="PickupCreate" title="Agendar recolección" on:close={() => ShipmentStore.modalRead()} >
    <PickupCreate on:created={() => ShipmentStore.modalRead()} on:canceled={() => ShipmentStore.modalRead()} />
</Modal>